export default { 
  Auth: require('./auth').default,
  Otp: require('./otp').default,
  User: require('./user').default,
  Public: require('./public').default,
  Errors: require('./errors').default,
  Maintenance: require('./template/Maintenance.vue').default,
}

